import React from "react";
import { Card, Form, Divider, Button, message, Table } from 'antd';

import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import NHFormItem from '../../common/NHFormItem';
import { getLoginUser } from "../../../utils/NHCore";
import PropTypes from 'prop-types';
import getSize from '../../../utils/getSize';
import {  NHConfirm } from '../../common/NHModal';
import styles from '../index.css'

const hjdm = "GD006_1";   //环节代码
const basicUrl = 'api/zhxg-yxxt/yxxc/';
const eszyUrl = 'api/zhxg-yxxt/eszy/yxxc/xcfp/'

/**
 * @author
 * @date 2020/8/18
 * @time 9:06
 * @Description: 迎新现场-现场分班(恩施职业)
 */
class EszyXcfb extends React.Component {
    constructor() {
        super();
        this.state = {
            majorList: [],            //专业列表
            bjlist: [],                            //班级列表
            bjlistbk: [],                             //班级列表备份
            selectbjid: '',                //选择的班级ID
            selectbjmc: '',                //选择的班级名称
            selectMajor: '',              //选择的班级名称
            loading: false,
            editable: true,
            selectedRowKeys: [],
        }
    }

    componentWillMount() {
        let that = this;
        this.setState({ scrollHeight: getSize().windowH - 206 });
        window.onresize = function () {
            that.setState({
                scrollHeight: getSize().windowH - 206,
            })
        }
    }



    componentDidMount() {
        let { xsid,zyid,bjid } = this.props.studentData;
        if (xsid) {
            this.getMajorList(xsid);
            this.getClassList(zyid);
            // 设置学生班级名称  学院  专业
            console.log(bjid)
            this.setState({ selectbjmc: this.props.studentData.bjmc,selectbjid:bjid })
            const selectedRowKeys = [];
            selectedRowKeys.push(bjid);
            if(this.state.selectedRowKeys.length == 0){

                this.setState({ selectedRowKeys:selectedRowKeys} )
            }
            return true;
        }
    }

    componentWillReceiveProps(nextProps) {
        //环节办理状态
        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (hjblztData) {
                let editable = hjblztData.blzt !== '1';
                this.setState({
                    editable: editable,
                });
            } else {
                this.setState({ editable: true });
            }
        }

        //学生数据
        if ('studentData' in nextProps) {
            const newStudentData = nextProps.studentData;
            const oldStudentData = this.props.studentData;
            //避免多次请求
            if ((Object.keys(newStudentData).length !== 0 && Object.keys(oldStudentData).length === 0) ||
                (Object.keys(newStudentData).length !== 0 && Object.keys(oldStudentData).length !== 0
                    && oldStudentData.xsid !== newStudentData.xsid)) {
                const { xsid } = newStudentData;
                if (xsid) {
                    return true;
                }
            }
        }
    }

    getMajorList = (xsid) => {
        NHFetch(eszyUrl + "getMajorList", 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data.length > 0) {
                    this.setState({
                        majorList: res.data,
                    });
                }
            })

    }


    //确定办理提交
    handleSubmit = () => {
        this.setState({ loading: true });
        const { xsid } = this.props.studentData;
        const { pkid } = this.props.hjblztData;
        let userId = getLoginUser() ? getLoginUser().userId : '';
        const selectbjid = this.state.selectbjid
        console.log(selectbjid)
        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            this.setState({ loading: false });
            return;
        }
        if (!selectbjid) {
            message.error("环节办理失败,请先选择班级！");
            this.setState({ loading: false });
            return;
        }
        const form = this.props.form;
        //校验
        form.validateFields((err, formData) => {
            if (err) {
                this.setState({ loading: false })
                return;
            }
            formData['classID'] = selectbjid
            let params = { xsid: xsid, lchjid: pkid, hjdm: hjdm, yhbh: userId, formData: formData }
            this.updateClassInfo(params)
        })
    };

    // 办理分班环节
    updateClassInfo = (params) => {
        NHFetch(eszyUrl + 'updateClassInfo', 'POST', params)
            .then(res => {
                if (res) {
                    if (res.data === 1) {
                        message.success('环节办理成功！');
                        this.setState({
                            editable: false
                        })
                        console.log(params)
                        this.getClassList(params['formData'].majorID)
                        //办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('submit');
                        }
                    } else {
                        message.error('环节办理失败，请重试！');
                    }
                    this.setState({ loading: false })
                } else {
                    message.error('环节办理失败，请重试！');
                    this.setState({ loading: false })
                }
            }).catch(() => {
                message.error('环节办理失败，请重试！');
                this.setState({ loading: false })
            })
    }



    //取消办理提交
    handleCancel = () => {
        const { pkid } = this.props.hjblztData;
        const { xsid, } = this.props.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, lchjid: pkid, hjdm: hjdm, bjid: '', yhbh: userId };
        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true });
            NHFetch(basicUrl + 'clearBJInfoByXsid', 'POST', params)
                .then(res => {
                    if (res && res.data === 1) {
                        message.success('环节办理取消成功！');
                        // 重新获取可选班级列表
                        this.getMajorList(xsid);
                        this.getClassList(this.props.studentData.zyid)
                        this.setState({
                            editable: true,
                            selectbjid: '',
                            selectbjmc: '',
                            selectedRowKeys: []
                        });
                        //取消办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('cancel');
                        }
                    } else {
                        message.error('环节办理取消失败，请重试！');
                    }
                    this.setState({ loading: false });
                }).catch(() => {
                    message.error("环节办理取消失败，请重试！");
                    this.setState({ loading: false });
                });
        }, "warn");
    };

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        const { onLast } = this.props;
        if (onLast) {
            onLast();
        }
    };

    //下一步
    handleNext = () => {
        const { onNext } = this.props;
        if (onNext) {
            onNext();
        }
    };

    getClassList = (value) => {
        NHFetch(eszyUrl + "getClassList", 'GET', { majorID: value })
            .then(res => {
                if (res && res.data.length > 0) {
                    const data = res.data;
                    this.setState({
                        bjlist: data[0].bjlist,
                        bjlistbk: data[0].bjlist
                    });
                }
            })
    }

   

    render() {
        const { editable, loading, majorList, bjlist, selectedRowKeys,} = this.state;
        const { lchjData = {}, hasLast, hasNext, form } = this.props;
        // 可选择班级表头
        const columns = [
            {
                title: '班级名称',
                dataIndex: 'bjmc',
                align: 'center',
                width: '22.5%'
            },
            {
                title: '已分配人数',
                dataIndex: 'yfprs',
                // render: text => <Progress percent={text}/>,
                align: 'center',
                width: '22.5%'
            },
            {
                title: '男生',
                dataIndex: 'malers',
                align: 'center',
                width: '22.5%'
            },
            {
                title: '女生',
                dataIndex: 'femalers',
                align: 'center',
                width: '22.5%'
            }
        ]
        const rowSelection = {
            type: 'radio',
            columnTitle: "选择",
            columnWidth: '10%',
            selectedRowKeys,

            onChange: (selectedRowKeys, selectedRows) => {

                this.setState({
                    selectbjid: selectedRows[0].bjid,
                    selectbjmc: selectedRows[0].bjmc,
                    selectedRowKeys
                })
           
                const bjlistbk = [...this.state.bjlistbk];
                //const fsex = this.state.fsex;
                const fsex = this.props.studentData.xb;
           
                //如果选中的班级不是当前学生的班级，则 增加班级已分配人数
                if ((selectedRows[0].bjid) != this.props.studentData.bjmc) {
                    this.setState({

                        bjlist: bjlistbk.map(
                            (item, index) => {
                                if (item.bjid === selectedRows[0].bjid && fsex === '女') {
                                    return { ...item, yfprs: parseInt(item.yfprs) + 1, femalers: parseInt(item.femalers) + 1 }

                                } else if (item.bjid === selectedRows[0].bjid && fsex === '男') {
                                    return { ...item, yfprs: parseInt(item.yfprs) + 1, malers: parseInt(item.malers) + 1 }
                                } else if (item.bjid === selectedRows[0].bjid) {
                                    return { ...item, yfprs: parseInt(item.yfprs) + 1 }
                                } else {
                                    return item
                                }
                            }
                        )
                    })
                }

            },
            getCheckboxProps: record => ({
                disabled: editable === false,
                name: record.name,
            })

        }
        const rowClassName = (record, index) => {
            return record.bjid === this.state.selectbjid || record.bjid === this.props.studentData.bjid ? styles.bjselected : '';

        }
        const { sfdybdd = '0' } = lchjData; //是否打印报到单
        return (
            <div>
                <Card type="inner" title="现场分班业务信息">
                    {
                        editable ?
                            <div>
                                <Form>
                                    <div style={{ fontWeight: 'bolder', marginBottom: '20px', color: '#262626' }}
                                        className={styles.xcfbtbl}
                                    >
                                        <NHFormItem id={"majorID"} label="选择专业" form={form} required={true} initialValue={this.props.studentData.zyid?this.props.studentData.zyid:''}>
                                            <NHSelect style={{ width: '50%' }} dataSource={majorList} onSelect={(value) => this.getClassList(value)} />
                                        </NHFormItem>
                                    </div>
                                    <Table
                                        columns={columns}
                                        dataSource={bjlist}
                                        pagination={false}
                                        rowSelection={rowSelection}
                                        rowClassName={rowClassName}
                                        rowKey="bjid"
                                        style={{ width: '90%', margin: '0px 40px' }}
                                    />
                                </Form>
                            </div> :
                            <div>
                            <div style={{ fontWeight: 'bolder', marginBottom: '20px', color: '#262626' }}
                                 className={styles.xcfbtbl}
                            >
                                {this.props.studentData.bmmc}-{this.props.studentData.zymc}-{this.props.studentData.bjmc}
                            </div>
                            <Table
                                columns={columns}
                                dataSource={bjlist}
                                pagination={false}
                                rowSelection={rowSelection}
                                rowClassName={rowClassName}
                                rowKey="bjid"
                                style={{ width: '90%', margin: '0px 40px' }}
                            />
                        </div>

                    }

                </Card>

                <Divider style={{ margin: '40px 0 24px' }} />
                {editable ? <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button> :
                    <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>}

                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast && <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button>
                }
                {
                    hasNext && <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button>
                }

                <style jsx="true" global="true">
                    {`
                        .ant-table-tbody>tr>td {
                            border-bottom: 1px solid #e8e8e8 !important;
                        }
                    `}
                </style>
            </div>
        )
    }
}

EszyXcfb.propTypes = {
    studentData: PropTypes.object,  //学生信息
    hjblztData: PropTypes.object,   //环节办理状态数据
    hjywxData: PropTypes.array,     //环节业务项数据
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool,        //是否有上一个环节
    hasNext: PropTypes.bool,        //是否有下一个环节
    onLast: PropTypes.func,         //上一步操作回调
    onNext: PropTypes.func,         //下一步操作回调
    onFinish: PropTypes.func,       //环节办理完成回调
    onPrint: PropTypes.func, //打印报到单
};

const eszyXcfb = Form.create()(EszyXcfb);
export default eszyXcfb;


// WEBPACK FOOTER //
// ./components/yxxc/steps/eszyXcfb.js